import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { green, indigo } from '@material-ui/core/colors'
import Box from 'atoms/layout/Box'
import Container from 'atoms/layout/Container'
import Typography from 'atoms/display/Typography'
import Grid from 'atoms/layout/Grid'
import Card from 'atoms/surfaces/card/Card'
import TimeImage from 'images/time.svg'
import MagnetImage from 'images/magnet.svg'
import NoWrap from 'atoms/display/NoWrap'
import ButtonLink from 'atoms/navigation/ButtonLink'

const useStyle = makeStyles(() => createStyles({
  magnetCard: {
    display: 'inline-block',
    background: indigo['800']
  },
  timeCard: {
    display: 'inline-block',
    background: green['800']
  }
}))

export default function Topics () {
  const classes = useStyle()

  return (
    <Container>
      <Box py={6}>
        <Typography variant="h4">
          主な研究トピック
        </Typography>
        <Box
          py={4} px={2}
        >
          <Grid
            container
            spacing={8}
          >
            <Grid
              item
              xs={12}
              spacing={4}
              alignItems="center"
            >
              <ButtonLink
                to="/research"
              >
                <Grid
                  container
                  spacing={4}
                  alignItems="center"
                >
                  <Grid
                    item
                    xs={2}
                    alignItems="center"
                  >
                    <Card
                      className={classes.timeCard}
                    >
                      <Box padding={2}>
                        <img src={TimeImage} alt="time" width="100%"/>
                      </Box>
                    </Card>
                  </Grid>
                  <Grid item container xs={10} alignItems="center">
                    <Grid item xs={12}>
                      <Typography align="left" variant="h6" fontWeight={700}>
                        非平衡系の科学 (時空間発展する現象の解明)
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography align="left" variant="body1">
                        <NoWrap>「生命とは何か？」を研究テーマにするとき様々な生命現象や研究方法があります。</NoWrap>
                        <NoWrap>これらの中で本研究室では、時空間発展する「自己組織化現象」をターゲットにして、</NoWrap>
                        <NoWrap>「非平衡開放系の観点」から解明する研究を行っています。</NoWrap>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </ButtonLink>
            </Grid>
            <Grid
              item
              xs={12}
              spacing={4}
            >
              <ButtonLink
                to="/jibaG-withKW.htm"
              >
                <Grid
                  container
                  spacing={4}
                  alignItems="center"
                >
                  <Grid
                    item
                    xs={2}
                    alignItems="center"
                  >
                    <Card
                      className={classes.magnetCard}
                    >
                      <Box padding={2}>
                        <img src={MagnetImage} alt="magnet" width="100%"/>
                      </Box>
                    </Card>
                  </Grid>
                  <Grid item container xs={10} alignItems="center">
                    <Grid item xs={12}>
                      <Typography align="left" variant="h6" fontWeight={700}>
                        磁気科学
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography align="left" variant="body1">
                        <NoWrap>「磁気科学」では、現代の社会⽣活における環境因子である</NoWrap>
                        <NoWrap>磁気，光，重力が生体反応や光化学反応に及ぼす影響，物質の磁気配向による組織化，</NoWrap>
                        <NoWrap>そして， それらの磁気無重力・過重力の影響の観察とその原理の解明が⽬的です。</NoWrap>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </ButtonLink>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  )
}
